(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ck-collection-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (event.target.matches('.ck-collection-products__sort-select')) event.target.form.requestSubmit();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const panel = event.target.closest('.ck-collection-products__filter[open]');
    if (panel) { panel.open = false; panel.querySelector('summary').focus(); }
  });
  document.addEventListener('click', (event) => {
    for (const panel of document.querySelectorAll('.ck-collection-products__filter[open]')) {
      if (!panel.contains(event.target)) panel.open = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-community"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if(root.dataset.loopReady) return;
    root.dataset.loopReady='true';
    const viewport=root.querySelector('.ck-ig-loop__viewport');
    const belt=root.querySelector('.ck-ig-loop__belt');
    const group=root.querySelector('.ck-ig-loop__group');
    if(!group.children.length)return;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    const control=root.querySelector('.ck-ig-loop__control');
    let paused=reduced.matches,hover=false,focused=false,touch=false,visible=false,last=0,position=0,frame=0,width=0;
    function updateControl(){if(control){control.setAttribute('aria-pressed',String(paused));control.setAttribute('aria-label',paused?control.dataset.playLabel:control.dataset.pauseLabel);}}
    if(control)control.addEventListener('click',()=>{paused=!paused;updateControl();});
    updateControl();
    const copies=[];
    const matchingPhoto=root.classList.contains('ck-ig-loop--compact')?null:document.querySelector('.ck-rider__media');
    function measure(){
      if(matchingPhoto){
        const rail=matchingPhoto.closest('.ck-riders__rail');
        const railStyle=getComputedStyle(rail);
        root.style.setProperty('--ck-ig-card-width',matchingPhoto.getBoundingClientRect().width+'px');
        root.style.setProperty('--ck-ig-gap',railStyle.columnGap);
        root.style.setProperty('--ck-ig-inset',railStyle.paddingLeft);
      }
      copies.forEach(copy=>copy.remove());copies.length=0;
      width=group.getBoundingClientRect().width;
      if(!width)return;
      const count=Math.max(1,Math.ceil(viewport.clientWidth/width));
      for(let i=0;i<count;i++){
        const copy=group.cloneNode(true);copy.setAttribute('aria-hidden','true');
        copy.querySelectorAll('a').forEach(a=>{a.tabIndex=-1;a.removeAttribute('data-shopify-editor-block');});
        belt.append(copy);copies.push(copy);
      }
      position=viewport.scrollLeft%width;
    }
    function tick(time){
      const delta=last?Math.min(time-last,50):0;last=time;
      if(visible&&!paused&&!hover&&!focused&&!touch&&!document.hidden&&width){
        position=(position+delta*0.025)%width;viewport.scrollLeft=position;
      }else{position=viewport.scrollLeft;}
      if(root.isConnected)frame=requestAnimationFrame(tick);
    }
    viewport.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')hover=true;});
    viewport.addEventListener('pointerleave',()=>{hover=false;});
    viewport.addEventListener('pointerdown',()=>{touch=true;});
    window.addEventListener('pointerup',()=>{touch=false;position=viewport.scrollLeft;});
    viewport.addEventListener('pointercancel',()=>{touch=false;});
    viewport.addEventListener('focusin',()=>{focused=true;});
    viewport.addEventListener('focusout',e=>{focused=viewport.contains(e.relatedTarget);});
    reduced.addEventListener('change',()=>{paused=reduced.matches;updateControl();});
    const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;});observer.observe(root);
    const resize=new ResizeObserver(measure);resize.observe(viewport);if(matchingPhoto)resize.observe(matchingPhoto);
    document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root)){cancelAnimationFrame(frame);observer.disconnect();resize.disconnect();}},{once:true});
    measure();frame=requestAnimationFrame(tick);
  }
  document.querySelectorAll('.ck-ig-loop').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.ck-ig-loop').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-custom-quote"] && !Shopify.designMode) return;
  try {
    
class ClassickMockup {
  constructor(root, form) {
    this.root=root;this.form=form;this.config=JSON.parse(root.querySelector('[data-mockup-config]').textContent);this.text=this.config.text;
    this.canvas=root.querySelector('canvas');this.ctx=this.canvas.getContext('2d',{willReadFrequently:true});if(!this.ctx)return;
    this.available=true;this.model='classic';this.face='side';this.height='middle';this.size=70;this.logo=null;this.original=null;this.fileName='';this.cache=new Map();this.request=0;this.uploadRequest=0;this.zoom=false;this.ready=false;
    this.status=root.querySelector('[data-mockup-status]');this.file=root.querySelector('[data-logo-file]');this.removeWhite=root.querySelector('[data-remove-white]');
    this.file.addEventListener('change',()=>this.upload(this.file.files[0]));
    this.removeWhite.addEventListener('change',()=>this.prepareLogo());
    root.querySelector('[data-remove-logo]').addEventListener('click',()=>this.clearLogo());
    root.querySelectorAll('[data-face]').forEach(button=>button.addEventListener('click',()=>{this.face=button.dataset.face;this.update();}));
    root.querySelectorAll('[data-height]').forEach(button=>button.addEventListener('click',()=>{this.height=button.dataset.height;this.update();}));
    root.querySelector('[data-logo-size]').addEventListener('input',event=>{this.size=Number(event.target.value);this.update();});
    root.querySelector('[data-zoom]').addEventListener('click',()=>{this.zoom=!this.zoom;this.update();});
    root.querySelector('[data-download]').addEventListener('click',()=>this.download());
    if(form){form.querySelectorAll('[name="contact[Product]"]').forEach(input=>input.addEventListener('change',()=>this.setProduct(input.value)));const selected=form.querySelector('[name="contact[Product]"]:checked');if(selected)this.setProduct(selected.value);}
    root.hidden=false;this.update();
  }
  setProduct(value){const entry=Object.entries(this.config.models).find(([,model])=>model.product===value);this.available=Boolean(entry);if(entry)this.model=entry[0];this.update();}
  say(message,error=false){this.status.textContent=message;this.status.dataset.error=String(error);}
  clearLogo(){this.uploadRequest++;this.logo=null;this.original=null;this.fileName='';this.file.value='';this.say(this.text.empty);this.update();}
  async upload(file){
    if(!file)return;const request=++this.uploadRequest;
    if(!['image/png','image/jpeg','image/webp'].includes(file.type)||file.size>10*1024*1024){this.file.value='';this.say(this.text.invalid,true);return;}
    this.say(this.text.loadingLogo);
    let url;
    try{
      url=URL.createObjectURL(file);const image=await this.loadImage(url,false);
      if(request!==this.uploadRequest)return;
      if(!image.naturalWidth||image.naturalWidth*image.naturalHeight>40000000)throw new Error('dimensions');
      const scale=Math.min(1,1000/Math.max(image.naturalWidth,image.naturalHeight));
      const canvas=document.createElement('canvas');canvas.width=Math.max(1,Math.round(image.naturalWidth*scale));canvas.height=Math.max(1,Math.round(image.naturalHeight*scale));canvas.getContext('2d').drawImage(image,0,0,canvas.width,canvas.height);
      this.original=canvas;this.fileName=file.name.slice(0,180);this.prepareLogo();
    }catch(error){if(request===this.uploadRequest){this.file.value='';this.say(this.text.invalid,true);}}
    finally{if(url)URL.revokeObjectURL(url);}
  }
  prepareLogo(){
    if(!this.original)return;
    const canvas=document.createElement('canvas');canvas.width=this.original.width;canvas.height=this.original.height;const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(this.original,0,0);
    const data=ctx.getImageData(0,0,canvas.width,canvas.height),pixels=data.data,w=canvas.width,h=canvas.height;
    if(this.removeWhite.checked){
      const seen=new Uint8Array(w*h),queue=new Int32Array(w*h);let start=0,end=0;
      const add=i=>{if(i<0||i>=seen.length||seen[i])return;seen[i]=1;const p=i*4;if(pixels[p+3]<10||Math.min(pixels[p],pixels[p+1],pixels[p+2])>228){queue[end++]=i;}};
      for(let x=0;x<w;x++){add(x);add((h-1)*w+x);}for(let y=0;y<h;y++){add(y*w);add(y*w+w-1);}
      while(start<end){const i=queue[start++],p=i*4;pixels[p+3]=0;const x=i%w;if(x>0)add(i-1);if(x<w-1)add(i+1);add(i-w);add(i+w);}
    }
    let left=w,top=h,right=-1,bottom=-1;
    for(let y=0;y<h;y++)for(let x=0;x<w;x++)if(pixels[(y*w+x)*4+3]>12){left=Math.min(left,x);right=Math.max(right,x);top=Math.min(top,y);bottom=Math.max(bottom,y);}
    if(right<left){this.logo=null;this.say(this.text.noVisible,true);this.update();return;}
    ctx.putImageData(data,0,0);const trimmed=document.createElement('canvas');trimmed.width=right-left+1;trimmed.height=bottom-top+1;trimmed.getContext('2d').drawImage(canvas,left,top,trimmed.width,trimmed.height,0,0,trimmed.width,trimmed.height);this.logo=trimmed;
    this.say(this.fileName+' · '+this.text.localFile);this.update();
  }
  loadImage(url,cors=true){return new Promise((resolve,reject)=>{const img=new Image();if(cors)img.crossOrigin='anonymous';img.onload=()=>resolve(img);img.onerror=reject;img.src=url;});}
  async getBase(){
    if(!this.cache.has(this.model)){const key=this.model;this.cache.set(key,this.loadImage(this.config.models[key].url).catch(error=>{this.cache.delete(key);throw error;}));}
    return this.cache.get(this.model);
  }
  update(){
    const model=this.config.models[this.model];this.root.querySelector('[data-unavailable]').hidden=this.available;this.root.querySelector('[data-mockup-available]').hidden=!this.available;this.root.querySelector('.cq-mockup-head').hidden=!this.available;
    this.root.querySelector('[data-model-name]').textContent=model.name;
    this.root.querySelector('[data-finish]').textContent=model.finish==='embroidered'?this.text.embroidered:this.text.printed;
    this.root.querySelector('[data-placement-caption]').textContent=this.text[this.face]+' · '+this.text[this.height];
    this.root.querySelector('[data-zip-note]').hidden=true;
    this.root.querySelectorAll('[data-face]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.face===this.face)));
    this.root.querySelectorAll('[data-height]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.height===this.height)));
    this.root.querySelector('[data-zoom]').setAttribute('aria-pressed',String(this.zoom));
    this.root.querySelector('[data-size-value]').textContent=this.size+'%';
    this.root.querySelector('[data-logo-controls]').disabled=!this.logo;
    this.root.querySelector('[data-remove-logo]').hidden=!this.original;
    const metadata={'Logoplaatsing':this.text[this.face],'Logohoogte':this.text[this.height],'Logogrootte':this.size+'% '+this.text.relativeSize,'Logoafwerking':model.finish==='embroidered'?this.text.embroidered:this.text.printed,'Logobestand (preview)':this.fileName+' '+this.text.fileMetadata};
    if(this.form){for(const [key,value]of Object.entries(metadata)){const input=this.form.elements.namedItem('contact['+key+']');if(input){input.disabled=!this.logo||!this.available;input.value=this.logo&&this.available?value:'';}}const note=this.form.querySelector('[data-logo-summary-note]');if(note)note.hidden=!this.logo||!this.available;}
    this.canvas.setAttribute('aria-label',model.name+' — '+this.text[this.face]+' — '+this.text[this.height]+'. '+this.text.indication);
    if(this.available)this.render();else{this.request++;this.ready=false;this.root.setAttribute('aria-busy','false');}
  }
  project(base){
    const model=this.config.models[this.model],view=model.views[this.face];
    const surface=document.createElement('canvas');surface.width=3072;surface.height=2048;const ctx=surface.getContext('2d',{willReadFrequently:true});ctx.drawImage(base,0,0,3072,2048);
    if(!this.logo)return surface;
    const level=['high','middle','low'].indexOf(this.height),cx=view.x[level]*2,cy=view.y[level]*2,maxWidth=view.width*this.size/50,maxHeight=260*this.size/100;
    const factor=Math.min(maxWidth/this.logo.width,maxHeight/this.logo.height),w=Math.max(1,Math.round(this.logo.width*factor)),h=Math.max(1,Math.round(this.logo.height*factor));
    const stamp=document.createElement('canvas');stamp.width=w;stamp.height=h;const stampCtx=stamp.getContext('2d',{willReadFrequently:true});stampCtx.drawImage(this.logo,0,0,w,h);const raw=stampCtx.getImageData(0,0,w,h).data;
    const margin=16,ow=w+margin*2,oh=h+margin*2,ox=Math.round(cx-ow/2),oy=Math.round(cy-oh/2);const fabric=ctx.getImageData(ox,oy,ow,oh).data;
    const layer=document.createElement('canvas');layer.width=ow;layer.height=oh;const lctx=layer.getContext('2d'),out=lctx.createImageData(ow,oh),embroidered=model.finish==='embroidered';
    for(let y=0;y<oh;y++)for(let x=0;x<ow;x++){
      const u=(x-margin)/Math.max(1,w-1)*2-1;if(Math.abs(u)>1)continue;
      const curve=.6,sx=(Math.asin(u*Math.sin(curve))/curve+1)/2*(w-1),sy=y-margin-(1-u*u)*4;
      if(sx<0||sx>w-1||sy<0||sy>h-1)continue;
      const ix=Math.floor(sx),iy=Math.floor(sy),fx=sx-ix,fy=sy-iy,di=(y*ow+x)*4;
      const sample=[0,0,0,0];
      for(let yy=0;yy<2;yy++)for(let xx=0;xx<2;xx++){
        const si=(Math.min(h-1,iy+yy)*w+Math.min(w-1,ix+xx))*4,weight=(xx?fx:1-fx)*(yy?fy:1-fy),alpha=raw[si+3]/255;
        sample[3]+=alpha*weight;for(let c=0;c<3;c++)sample[c]+=raw[si+c]*alpha*weight;
      }
      if(sample[3]<.005)continue;for(let c=0;c<3;c++)sample[c]/=sample[3];
      const luminance=(fabric[di]+fabric[di+1]+fabric[di+2])/765;
      const thread=embroidered?(Math.sin((x*.5+y*.08)*3.6)*.5+.5)*25:0;
      const shade=Math.max(.48,Math.min(1.08,luminance));
      const neighbor=(Math.max(0,iy-2)*w+Math.max(0,ix-1))*4+3,edge=embroidered?Math.max(0,sample[3]-raw[neighbor]/255)*16:0;
      for(let c=0;c<3;c++)out.data[di+c]=Math.min(255,(sample[c]*(embroidered?.91:1)+(embroidered?thread:0))*shade+edge);
      out.data[di+3]=Math.round(sample[3]*255*(embroidered?1:.98));
    }
    lctx.putImageData(out,0,0);ctx.save();if(embroidered){ctx.shadowColor='rgba(0,0,0,.25)';ctx.shadowBlur=2.4;ctx.shadowOffsetX=.8;ctx.shadowOffsetY=1.6;}ctx.drawImage(layer,ox,oy);ctx.restore();return surface;
  }
  async render(){
    const request=++this.request;this.ready=false;this.root.querySelector('[data-download]').disabled=true;this.root.setAttribute('aria-busy','true');
    try{
      const base=await this.getBase();if(request!==this.request)return;
      const surface=this.project(base),view=this.config.models[this.model].views[this.face],level=['high','middle','low'].indexOf(this.height);
      const crop=this.zoom?[view.x[level]-175,Math.max(0,view.y[level]-230),350,460]:view.crop;
      this.canvas.width=700;this.canvas.height=this.zoom?820:1000;const ctx=this.ctx;ctx.fillStyle='#eeeeee';ctx.fillRect(0,0,this.canvas.width,this.canvas.height);
      const scale=Math.min(this.canvas.width/crop[2],this.canvas.height/crop[3]),dw=crop[2]*scale,dh=crop[3]*scale;
      ctx.drawImage(surface,...crop.map(n=>n*2),(this.canvas.width-dw)/2,(this.canvas.height-dh)/2,dw,dh);
      this.surface=surface;this.ready=true;this.root.querySelector('[data-download]').disabled=false;
    }catch(error){if(request===this.request){this.ctx.clearRect(0,0,this.canvas.width,this.canvas.height);this.say(this.text.loadError,true);}}
    finally{if(request===this.request)this.root.setAttribute('aria-busy','false');}
  }
  download(){
    if(!this.ready||!this.surface)return;const output=document.createElement('canvas');output.width=1800;output.height=1400;const ctx=output.getContext('2d');ctx.fillStyle='#fff';ctx.fillRect(0,0,1800,1400);ctx.fillStyle='#111';ctx.font='bold 34px Arial';ctx.fillText('CLASSICK / CUSTOM',66,65);ctx.font='22px Arial';ctx.fillText(this.config.models[this.model].name+' · '+(this.config.models[this.model].finish==='embroidered'?this.text.embroidered:this.text.printed),66,105);ctx.drawImage(this.surface,50,130,1700,1133);ctx.font='20px Arial';ctx.fillText(this.text.indication,66,1305);ctx.fillText(this.text.designerExport,66,1340);
    try{output.toBlob(blob=>{if(!blob){this.say(this.text.downloadError,true);return;}const url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download='classick-'+this.model+'-'+this.face+'-'+this.height+'-voorbeeld.png';document.body.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),10000);},'image/png');}catch(error){this.say(this.text.downloadError,true);}
  }
}


(function(){
  function init(root){
    const figures=Array.from(root.querySelectorAll('[data-product-photo]'));
    function selectPhoto(product){figures.forEach((figure,i)=>figure.hidden=product?figure.dataset.productPhoto!==product:i!==0);}
    selectPhoto();
    const inspiration=root.querySelector('.cq-inspiration-modal');
    const inspirationOpen=root.querySelector('[data-inspiration-open]');
    inspirationOpen.addEventListener('click',()=>inspiration.showModal());
    inspiration.querySelector('[data-inspiration-close]').addEventListener('click',()=>inspiration.close());
    inspiration.addEventListener('click',event=>{if(event.target!==inspiration)return;const rect=inspiration.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)inspiration.close();});
    inspiration.addEventListener('close',()=>inspirationOpen.focus({preventScroll:true}));
    const dialog=root.querySelector('.cq-lightbox');
    root.querySelectorAll('[data-catalog-open]').forEach(button=>button.addEventListener('click',()=>{dialog.querySelector('h3').textContent=button.dataset.title;const image=dialog.querySelector('img');image.src=button.dataset.image;image.alt=button.dataset.title;dialog.showModal();}));
    dialog.querySelector('[data-catalog-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
    const form=root.querySelector('.cq-form');
    if(!form || form.dataset.ready)return;
    form.dataset.ready='true';
    const panels=Array.from(form.querySelectorAll('.cq-panel'));
    if(!panels.length)return;
    const progress=form.querySelector('.cq-progress'),next=form.querySelector('.cq-next'),back=form.querySelector('.cq-back'),submit=form.querySelector('.cq-submit'),summary=form.querySelector('.cq-summary');
    let step=0,mockup=null;
    const text=JSON.parse(root.dataset.cqText || '{}');
    const translate=(key,values={})=>String(text[key] || '').replace(/__([a-z_]+)__/g,(token,name)=>String(values[name] ?? token));
    const locale=document.documentElement.lang || 'en';
    const deliveryDate=form.elements.namedItem('contact[Gewenste leverdatum]');
    function dateRules(initial=false){
      const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Amsterdam',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const part=name=>Number(parts.find(item=>item.type===name).value);
      const product=form.querySelector('input[name="contact[Product]"]:checked');
      const days=Number(product?.dataset.leadDays || 42);
      const minimum=new Date(Date.UTC(part('year'),part('month')-1,part('day')+days)).toISOString().slice(0,10);
      const previousMinimum=deliveryDate.min;
      deliveryDate.min=minimum;
      if((initial&&(!deliveryDate.value||deliveryDate.value===deliveryDate.defaultValue))||(previousMinimum!==minimum&&(!deliveryDate.value||deliveryDate.value===previousMinimum||deliveryDate.value<minimum)))deliveryDate.value=minimum;
      const hint=form.querySelector('.cq-date .cq-small');
      if(hint)hint.textContent=translate(days===2?'date_fast':'date_slow');
    }
    dateRules(true);
    deliveryDate.addEventListener('focus',()=>dateRules());
    const quantity=form.elements.namedItem('contact[Aantal]'),audience=form.elements.namedItem('contact[Voor wie]'),pack=form.querySelector('.cq-packaging'),packField=form.elements.namedItem('contact[Verpakking]'),rule=form.querySelector('.cq-product-rule'),lead=form.elements.namedItem('contact[Levertijd]');
    const quantityButtons=Array.from(form.querySelectorAll('[data-quantity]'));
    const options=form.querySelector('.cq-quantity-options');options.hidden=false;
    function productRules(){
      const product=form.querySelector('input[name="contact[Product]"]:checked');
      selectPhoto(product?.value);
      const minimum=Number(product?.dataset.min||50);quantity.min=String(minimum);
      lead.value=product?.dataset.lead||'';
      if(product)rule.textContent=product.parentElement.querySelector('.cq-product-meta').textContent;
      const selectionInfo=form.querySelector('.cq-selection-info');
      selectionInfo.hidden=!product;
      if(product)selectionInfo.textContent=product.parentElement.querySelector('strong').textContent+' — '+rule.textContent;
      dateRules();
      quantityButtons.forEach(button=>{button.hidden=Number(button.dataset.quantity)<minimum;button.setAttribute('aria-pressed',String(button.dataset.quantity===quantity.value));});
    }
    function packaging(){const retail=audience.value==='Winkel';pack.hidden=!retail;packField.disabled=!retail;}
    form.querySelectorAll('input[name="contact[Product]"]').forEach(input=>input.addEventListener('change',productRules));
    quantityButtons.forEach(button=>button.addEventListener('click',()=>{quantity.value=button.dataset.quantity;productRules();}));
    quantity.addEventListener('input',productRules);audience.addEventListener('change',packaging);
    productRules();packaging();
    function show(n,focus){
      if(n===2&&!mockup){const component=form.querySelector('.cq-mockup');if(component)mockup=new ClassickMockup(component,form);}
      step=n;progress.style.setProperty('--cq-progress',String(n/3*100)+'%');panels.forEach((p,i)=>{p.hidden=i!==n;});
      Array.from(progress.children).forEach((li,i)=>{li.dataset.complete=String(i<n);if(i===n)li.setAttribute('aria-current','step');else li.removeAttribute('aria-current');});
      next.hidden=n===3;back.hidden=n===0;submit.hidden=n!==3;
      if(n===3){
        summary.replaceChildren();
        ['Product','Voor wie','Aantal','Levertijd','Verpakking','Gewenste leverdatum','Ontwerpstatus','Kleuren','Logoplaatsing','Logohoogte','Logogrootte','Logoafwerking','Logobestand (preview)','Ontwerplink'].forEach(key=>{
          const field=form.elements.namedItem('contact['+key+']');
          if(field && !field.disabled && field.value){
            const dt=document.createElement('dt'),dd=document.createElement('dd');
            dt.textContent=text.labels?.[key] || key;
            dd.textContent=key==='Aantal'?translate('quantity_value',{count:field.value}):key==='Gewenste leverdatum'?new Intl.DateTimeFormat(locale,{dateStyle:'long',timeZone:'UTC'}).format(new Date(field.value+'T12:00:00Z')):key==='Product'?form.querySelector('input[name="contact[Product]"]:checked').parentElement.querySelector('strong').textContent:field.tagName==='SELECT'?field.selectedOptions[0].textContent:field.value;
            summary.append(dt,dd);
          }
        });summary.hidden=false;
      }
      if(focus)panels[n].querySelector('h3').focus();
    }
    function valid(n){dateRules();productRules();packaging();const invalid=Array.from(panels[n].querySelectorAll('input,select,textarea')).find(el=>!el.checkValidity());if(invalid){show(n,false);invalid.reportValidity();return false;}return true;}
    progress.hidden=false;form.noValidate=true;
    next.addEventListener('click',()=>{if(valid(step))show(step+1,true);});
    back.addEventListener('click',()=>show(step-1,true));
    form.addEventListener('submit',event=>{
      for(let i=0;i<panels.length;i++){if(!valid(i)){event.preventDefault();return;}}
    });
    form.addEventListener('keydown',event=>{if(event.key==='Enter' && event.target.tagName==='INPUT' && step<3){event.preventDefault();next.click();}});
    show(0,false);
  }
  document.querySelectorAll('.cq').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.cq').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ck-newsletter-popup]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    if (root.dataset.enabled !== 'true' || root.dataset.subscribed === 'true') return;
    // This gates theme-triggered forms only. Klaviyo's own timer needs matching URL exclusions.
    const purchasePage = () => ['product', 'cart'].includes(root.dataset.pageType)
      || /\/(products|cart|checkout|checkouts)(\/|$)/.test(location.pathname);
    if (purchasePage()) return;
    const visible = (element) => element && element.getClientRects().length > 0
      && getComputedStyle(element).visibility !== 'hidden';
    const openingBlocked = () => purchasePage() || document.visibilityState !== 'visible'
      || ['shopify-pc__banner', 'shopify-pc__prefs__dialog'].some(id => visible(document.getElementById(id)))
      || [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')].some(visible)
      || !!document.activeElement?.closest('input, select, textarea, [contenteditable="true"], product-form-component, variant-picker, sticky-add-to-cart');
    if (root.dataset.klaviyoFormId) {
      const formId = root.dataset.klaviyoFormId;
      const isPreview = root.dataset.themeRole !== 'main' && new URLSearchParams(location.search).get('ck_banner_preview') === '1';
      const dismissedKey = 'ck-klaviyo-' + formId + '-dismissed';
      const subscribedKey = 'ck-klaviyo-' + formId + '-subscribed';
      const viewedKey = 'ck-klaviyo-' + formId + '-viewed';
      let opened = false;
      let timer;
      let delayTimer;
      let suppressed = false;
      try { suppressed = localStorage.getItem(subscribedKey) === 'true' || Date.now() - Number(localStorage.getItem(dismissedKey) || 0) < 1209600000 || sessionStorage.getItem(viewedKey) === 'true'; } catch (error) {}
      if (suppressed && !isPreview) return;
      window.addEventListener('klaviyoForms', event => {
        if (event.detail?.formId !== formId || isPreview) return;
        if (event.detail.type === 'open') opened = true;
        if (['close', 'submit'].includes(event.detail.type)) suppressed = true;
        if (opened || suppressed) cleanup();
        try {
          if (event.detail.type === 'open') sessionStorage.setItem(viewedKey, 'true');
          if (event.detail.type === 'close') localStorage.setItem(dismissedKey, String(Date.now()));
          if (event.detail.type === 'submit') localStorage.setItem(subscribedKey, 'true');
        } catch (error) {}
      });
      const cleanup = () => {
        clearInterval(timer);
        clearTimeout(delayTimer);
        window.removeEventListener('scroll', tryOpen);
        document.removeEventListener('visibilitychange', tryOpen);
      };
      const tryOpen = () => {
        if (!root.isConnected) { cleanup(); return; }
        if (opened || (suppressed && !isPreview)) { cleanup(); return; }
        if (openingBlocked()) return;
        if (!isPreview && window.scrollY <= 200) return;
        if (!window.klaviyo && !window._klOnsite) return;
        opened = true;
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
        if (!isPreview) { try { sessionStorage.setItem(viewedKey, 'true'); } catch (error) {} }
        cleanup();
      };
      delayTimer = window.setTimeout(() => {
        window.addEventListener('scroll', tryOpen, { passive: true });
        document.addEventListener('visibilitychange', tryOpen);
        timer = window.setInterval(tryOpen, 1000);
        tryOpen();
      }, isPreview ? 1000 : Number(root.dataset.delay || 25) * 1000);
      return;
    }
    const dialog = root.querySelector('.ck-newsletter-popup__dialog');
    const close = root.querySelector('[data-ck-popup-close]');
    const copy = root.querySelector('[data-ck-popup-copy]');
    let previousFocus;
    dialog.addEventListener('close', () => previousFocus?.focus());
    const hasFeedback = Boolean(root.querySelector('[data-ck-popup-success], [data-ck-popup-error]'));
    const storageKey = 'ck-newsletter-popup-dismissed';
    const rememberDismissal = () => {
      try { localStorage.setItem(storageKey, String(Date.now())); } catch (error) {}
    };
    const closeDialog = () => {
      rememberDismissal();
      if (dialog.open) dialog.close();
    };
    close.addEventListener('click', closeDialog);
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    if (copy) {
      copy.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(copy.dataset.code);
          const label = copy.querySelector('small');
          if (label) label.textContent = 'Gekopieerd';
        } catch (error) {}
      });
    }
    let dismissedRecently = false;
    try {
      const dismissedAt = Number(localStorage.getItem(storageKey) || 0);
      dismissedRecently = Date.now() - dismissedAt < 1209600000;
    } catch (error) {}
    if (hasFeedback || root.dataset.designMode === 'true') {
      previousFocus = document.activeElement;
      dialog.showModal();
    } else if (!dismissedRecently) {
      window.setTimeout(() => {
        const tryOpen = () => {
          if (!root.isConnected || dialog.open || openingBlocked() || window.scrollY <= 200) return;
          previousFocus = document.activeElement;
          dialog.showModal();
          window.removeEventListener('scroll', tryOpen);
          document.removeEventListener('visibilitychange', tryOpen);
        };
        window.addEventListener('scroll', tryOpen, { passive: true });
        document.addEventListener('visibilitychange', tryOpen);
        tryOpen();
      }, Number(root.dataset.delay || 7) * 1000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ck-product-selector"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ck-selector]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const result = root.querySelector('[data-ck-selector-result]');
    const title = root.querySelector('[data-ck-selector-title]');
    const copy = root.querySelector('[data-ck-selector-copy]');
    const link = root.querySelector('[data-ck-selector-link]');
    const gloveNudge = root.querySelector('.ck-selector__glove-nudge');
    const mobileToggle = root.querySelector('[data-ck-selector-toggle]');
    const mobileToggleIcon = root.querySelector('[data-ck-selector-toggle-icon]');
    const recommendations = {
      socks_race: ['CLS Aero Socks', 'Snelste keuze op hoge snelheden — strakke aero race-fit, gemaakt in Italië.', '/products/cls-aero-socks-white-logo-classick'],
      socks_training: ['C1 EVO Aero Socks', 'Snelste allround aero-stof — gemaakt in Italië voor koers én training.', '/products/aero-wielersok-c1-graphite-grey-classick'],
      socks_wet: ['Classic Socks + Flandrien', 'Comfortabele sokken uit Italië, gecombineerd met spatwaterproof bescherming.', '/products/flandrien-shoe-covers-wit'],
      overshoes_race: ['SF2.0 Aero Overschoenen', '±8W aero gain en een strakke race-fit — geproduceerd in Italië met Italiaanse materialen.', '/products/aero-overschoenen-sf2-0'],
      overshoes_training: ['SF2.0 Aero Overschoenen', 'Pure aero performance voor snelle trainingen en wedstrijddagen.', '/collections/aero-overschoenen'],
      overshoes_wet: ['Flandrien Shoe Covers', 'Spatwaterproof bescherming voor nat wegdek en vuile klassiekerritten.', '/products/flandrien-shoe-covers-wit'],
      essentials_race: ['Aero Essentials', 'Base layer, gloves, wraps en aero-accessoires voor een complete kit met sick aero gains.', '/collections/aero-essentials'],
      essentials_training: ['Training Essentials', 'Technische lagen, grip en comfortabele sokken voor snelle trainingen en lange dagen.', '/collections/training-essentials'],
      essentials_wet: ['Regen Essentials', 'Flandrien bescherming, extra grip en slimme lagen voor natte, koude klassiekerritten.', '/collections/regen-essentials'],
      unknown_race: ['Aero Essentials', 'De complete Classick performance-selectie voor snelheid en sick aero gains.', '/collections/aero-essentials'],
      unknown_training: ['Training Essentials', 'De sterkste combinatie voor dagelijkse kilometers, comfort en tempo.', '/collections/training-essentials'],
      unknown_wet: ['Regen Essentials', 'Spatwaterproof bescherming, grip en slimme lagen voor natte en vuile ritten.', '/collections/regen-essentials'],
      team: ['Custom Classick', 'Een premium, race-ready ontwerp voor jouw club, team of event.', '/pages/custom-aero-sokken']
    };
    form.addEventListener('change', () => {
      const product = new FormData(form).get('product');
      const ride = new FormData(form).get('ride');
      if (!product || !ride) return;
      const key = ride === 'team' ? 'team' : `${product}_${ride}`;
      const recommendation = recommendations[key];
      title.textContent = recommendation[0];
      copy.textContent = recommendation[1];
      link.href = recommendation[2];
      gloveNudge.hidden = product === 'essentials';
      result.hidden = false;
    });
    mobileToggle?.addEventListener('click', () => {
      const isOpen = root.classList.toggle('is-mobile-open');
      mobileToggle.setAttribute('aria-expanded', String(isOpen));
      mobileToggleIcon.textContent = isOpen ? '−' : '+';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  function initUsp(root) {
    root.querySelectorAll('[data-usp-loop]').forEach(el => {
      if (el.dataset.uspReady) return;
      el.dataset.uspReady = 'true';
      const messages = [el.dataset.uspOne, el.dataset.uspTwo, el.dataset.uspThree, el.dataset.uspFour];
      let index = 0;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const timer = setInterval(() => {
        if (!el.isConnected) { clearInterval(timer); return; }
        if (document.hidden || document.documentElement.classList.contains('ck-usp-hidden')) return;
        index = (index + 1) % messages.length;
        el.textContent = messages[index];
        if (!motion.matches) el.animate([{opacity: 0, transform: 'translateY(3px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 350, easing: 'ease-out'});
      }, 4500);
    });
  }
  initUsp(document);
  document.addEventListener('shopify:section:load', e => initUsp(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
